import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../data/content";
import { responsive } from "../lib/img";

const Slideshow = ({ images, interval = 3200 }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);
  return (
    <div className="absolute inset-0">
      <AnimatePresence mode="sync">
        <motion.img key={i} {...responsive(images[i], "(min-width: 1024px) 60vw, 100vw", [480, 800, 1200])} decoding="async" alt="Real Speedy court project"
          initial={{ opacity: 0, scale: 1.06 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }} className="absolute inset-0 h-full w-full object-cover" />
      </AnimatePresence>
      {/* progress dots */}
      <div className="absolute top-3 inset-x-3 flex gap-1.5 z-10">
        {images.map((_, d) => (
          <span key={d} className={`h-0.5 flex-1 rounded-full transition-colors duration-500 ${d === i ? "bg-neon" : "bg-white/25"}`} />
        ))}
      </div>
    </div>
  );
};

const Frame = ({ label, sub, children, testid }) => (
  <div className="relative aspect-[9/16] overflow-hidden rounded-xl ring-1 ring-white/15 bg-obsidian-800 shadow-[0_40px_90px_rgba(0,0,0,0.8)]" data-testid={testid}>
    {children}
    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-obsidian via-obsidian/60 to-transparent pt-14 pb-4 px-4 pointer-events-none">
      <p className="font-heading font-black text-base leading-tight">{label}</p>
      <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-gold mt-1">{sub}</p>
    </div>
  </div>
);

export default function TransformationReel() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-4xl">
      <Frame label="ON THE TOOLS" sub="Real Speedy courts · on site" testid="reel-video">
        <Slideshow images={[IMAGES.speedyBball, IMAGES.tanTeal, IMAGES.nightTennis]} interval={3000} />
      </Frame>
      <Frame label="BACKYARD GOALS" sub="Home courts · Sydney" testid="reel-homes">
        <Slideshow images={[IMAGES.jordanBackyard, IMAGES.backyardBlue]} />
      </Frame>
      <Frame label="SCHOOLS & CLUBS" sub="Community courts · NSW" testid="reel-schools">
        <Slideshow images={[IMAGES.redSchool, IMAGES.greenNetball, IMAGES.tanHoop]} interval={3600} />
      </Frame>
    </div>
  );
}

export const ReelCta = () => (
  <Link to="/gallery" className="inline-flex items-center gap-2 text-gold hover:text-gold-hover font-bold" data-testid="reel-gallery-link">
    See every transformation <ArrowUpRight size={18} />
  </Link>
);
